// src/types/site.ts - Lieux / sites pour le stock multi-sites (magasin + boutique)

import { createI18nLabelMap } from '../utils/i18n/getStatusLabel';

/** Type de lieu : entrepôt (reçoit les appro) ou point de vente (stock de vente, lieu par défaut pour le POS). */
export type SiteType = 'warehouse' | 'point_of_sale';

export const SITE_TYPE_LABELS: Record<SiteType, string> = createI18nLabelMap(
  'siteType',
  ['warehouse', 'point_of_sale'] as const
);

export interface Site {
  id: string;
  businessId: string;
  name: string;
  type: SiteType;
  /** Ordre d'affichage (optionnel). */
  order?: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt?: Date;
}
